<template>
  <div class="page_ table_textc">
    <div>
      <a-form layout="inline">
        <a-form-item label="保单号 ">
          <a-input
            class="min_input_"
            style="width: 200px;"
            v-model="policyNoi"
            placeholder="请输入保单号"
          ></a-input>
        </a-form-item>
        <a-form-item label="投保日期">
          <a-range-picker
            :placeholder="['请选择日期', '请选择日期']"
            style="width: 215px;"
            @change="rangeDate"
            :value="createValue"
          ></a-range-picker>
        </a-form-item>
        <a-form-item label="投保人">
          <a-input class="min_input_" v-model="holderNamei"></a-input>
        </a-form-item>
        <a-form-item label="被保人">
          <a-input class="min_input_" v-model="insuredNamei"></a-input>
        </a-form-item>
        <!-- <a-form-item label="关联保单">
                <a-input class="min_input_"></a-input>
            </a-form-item> -->
        <a-form-item>
          <a-button type="primary" @click="searchData()">查询</a-button>
          <a-button style="margin-left: 8px;" type="default" @click="initData()"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>
    <a-table
      style="margin-top: 17px;"
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      @change="handlePageChange"
      class="table_b table_nowrap"
    >
      <span slot="operation" slot-scope="text, record" class="span_btn">
        <a
          href="javascript:void(0);"
          @click="goDetail(record.policyId, record.policyNo, record)"
          >保单详情</a
        >
        <a
          href="javascript:void(0);"
          @click="getUrl(record.downLoadUrl, record.policyNo)"
          target="_blank"
          >电子保单</a
        >
        <!-- <a href="javascript:void(0);" @click="correct(record.policyId,record)">保单批改</a> -->
      </span>
    </a-table>
    <div class="fixbg_" v-if="showDetail">
      <div class="fixcon" @click.stop v-if="step === 1" v-drag>
        <p style="border-bottom:none;">保单详情</p>
        <span class="close_" @click.stop="closeFix()"></span>
        <div class="detail">
          <div class="table_">
            <table>
              <tr>
                <td colspan="6" class="bold">保单信息</td>
              </tr>
              <tr>
                <td>保单号：</td>
                <td>{{ policyNo }}</td>
                <td>起保日期：</td>
                <td>
                  {{ policyDetail.effectiveDateStr }}
                </td>
                <td>终保日期：</td>
                <td>{{ policyDetail.expireDateStr }}</td>
              </tr>
              <tr>
                <td>保单状态：</td>
                <td>
                  {{
                    policyDetail.salPolicy.status | filterType(statusOptions)
                  }}
                </td>
                <td>保费：</td>
                <td colspan="3">{{ policyDetail.salPolicy.totalPremium }}</td>
              </tr>
            </table>
          </div>
          <div class="table_">
            <table>
              <tr>
                <td colspan="6" class="bold">投保人信息</td>
              </tr>
              <tr>
                <td>投保人名称：</td>
                <td>{{ policyDetail.salPolicyHolder.name }}</td>
                <td>证件类型：</td>
                <td>
                  {{
                    policyDetail.salPolicyHolder.idType
                      | filterIdType(idTypeOptions)
                  }}
                </td>
                <td>证件号码:</td>
                <td>{{ policyDetail.salPolicyHolder.idNumber }}</td>
              </tr>
              <tr>
                <td>性别：</td>
                <td>
                  {{
                    policyDetail.salPolicyHolder.gender | filterSex(sexOptions)
                  }}
                </td>
                <td>出生日期：</td>
                <td colspan="3">
                  {{
                    policyDetail.salPolicyHolder.birthDate.indexOf("-") === -1
                      ? policyDetail.salPolicyHolder.birthDate.substring(0, 4) +
                        "-" +
                        policyDetail.salPolicyHolder.birthDate.substring(4, 6) +
                        "-" +
                        policyDetail.salPolicyHolder.birthDate.substring(6, 8)
                      : policyDetail.salPolicyHolder.birthDate
                  }}
                </td>
              </tr>
            </table>
          </div>
          <div class="table_">
            <table>
              <tr>
                <td colspan="6" class="bold">被保人信息</td>
              </tr>
              <tr>
                <th>序号</th>
                <th>被保人名称</th>
                <th>证件类型</th>
                <th>证件号码</th>
                <th>性别</th>
                <th>出生日期</th>
              </tr>
              <tr v-for="(itemp, indexp) in policyDetail.salInsuredList">
                <td>{{ indexp + 1 }}</td>
                <td>{{ itemp.name }}</td>
                <td>{{ itemp.idType | filterIdType(idTypeOptions) }}</td>
                <td>{{ itemp.idNumber }}</td>
                <td>{{ itemp.gender | filterSex(sexOptions) }}</td>
                <td>
                  {{
                    itemp.birthDate.indexOf("-") === -1
                      ? itemp.birthDate.substring(0, 4) +
                        "-" +
                        itemp.birthDate.substring(4, 6) +
                        "-" +
                        itemp.birthDate.substring(6, 8)
                      : itemp.birthDate
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="btn_b">
          <a-button
            :class="[isAfter ? 'gray_' : '']"
            :disabled="isAfter"
            @click.stop="goSurrender()"
            >退保</a-button
          >
          <a-button
            :class="[isAfter ? 'gray_' : '']"
            :disabled="isAfter"
            @click.stop="correct()"
            >批改</a-button
          >
        </div>
      </div>
      <div class="fixcon" @click.stop v-if="step === 2" v-drag>
        <p style="border-bottom:none;">保单退保</p>
        <span class="close_" @click.stop="closeFix()"></span>
        <div class="detail">
          <div class="forminfo_ cor_date">
            <div class="infoitem">
              <span>批改生效日期：</span>
              <div class="itemright datei_">
                <a-date-picker
                  @change="onChangeS"
                  :defaultValue="
                      moment(
                        policyDetail.effectiveDateStr != ''
                          ? policyDetail.effectiveDateStr.substring(0, 10)
                          : '',
                      dateFormat
                    )
                  "
                  :format="dateFormat"
                  :disabledDate="disabledDate"
                  :showToday="false"
                  :allowClear="false"
                />
              </div>
            </div>
            <div class="infoitem">
              <span>保单起保日期:</span>
              <div class="itemright">
                <input
                  type="text"
                  :value="
                    policyDetail.effectiveDateStr != ''
                      ? policyDetail.effectiveDateStr
                      : ''
                  "
                  readonly
                />
              </div>
            </div>
            <div class="infoitem">
              <span>保单终保日期:</span>
              <div class="itemright">
                <input
                  type="text"
                  :value="policyDetail.expireDateStr"
                  readonly
                />
              </div>
            </div>
            <div class="infoitem" v-stopdrag>
              <span>产品类型:</span>
              <div class="itemright">
                <input type="text" value="在线退保" readonly />
              </div>
            </div>
          </div>
          <p>
            本次批改操作将退还保费{{
              policyDetail.salPolicy.totalPremium
            }}元，您确定要批改吗？
          </p>
          <div class="forminfo_">
            <div class="infoitem fl_2" v-stopdrag>
              <span>付款方式:</span>
              <div class="itemright">
                <input type="text" value="转账" readonly />
              </div>
            </div>
            <div class="infoitem fl_2" v-stopdrag>
              <span>银行区域:</span>
              <div class="itemright">
                <a-select
                  dropdownClassName="drop_"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  @change="areaChange"
                  v-model="defaultProvince"
                  placeholder="请选择银行区域"
                >
                  <a-select-option
                    :value="itemP.value"
                    v-for="(itemP, indexP) in provinceOptions"
                    :key="indexP"
                  >
                    {{ itemP.text }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="forminfo_" v-stopdrag>
            <div class="infoitem fl_2">
              <span>银行名称:</span>
              <div class="itemright">
                <a-select
                  dropdownClassName="drop_"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  @change="bankChange"
                  v-model="defaultBank"
                  placeholder="请选择银行名称"
                >
                  <a-select-option
                    :value="itemB.value"
                    v-for="(itemB, indexB) in bankOptions"
                    :key="indexB"
                  >
                    {{ itemB.text }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="infoitem fl_2" v-stopdrag>
              <span>开户行:</span>
              <div class="itemright">
                <a-select
                  dropdownClassName="drop_"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  v-model="defaultBankLoc"
                  @change="bankChildChange"
                  placeholder="请选择开户行"
                >
                  <a-select-option
                    :value="itemBL.value"
                    v-for="(itemBL, indexBL) in bankLocOptions"
                    :key="indexBL"
                  >
                    {{ itemBL.text }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="forminfo_" v-stopdrag>
            <div class="infoitem fl_2">
              <span>户名:</span>
              <div class="itemright">
                <input
                  type="text"
                  placeholder="请输入户名"
                  v-model="accountName"
                  readonly
                />
              </div>
            </div>
            <div class="infoitem fl_2" v-stopdrag>
              <span>银行卡号:</span>
              <div class="itemright">
                <input
                  type="text"
                  placeholder="请输入银行卡号"
                  v-model="accountNo"
                />
              </div>
            </div>
          </div>
          <div class="forminfo_" v-stopdrag>
            <div class="infoitem">
              <span>备注:</span>
              <div class="itemright">
                <input
                  placeholder="请输入备注内容"
                  v-model="remark"
                  style="width:500px;"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="btn_b">
          <button @click="sureSurrender()">确认退保</button>
        </div>
      </div>
    </div>
    <div class="fixbg_" v-if="showCorrect">
      <div class="fixcon" @click.stop v-drag>
        <p>保单批改</p>
        <span class="close_" @click.stop="closeFix()"></span>
        <div class="detail">
          <div class="policy_info" v-stopdrag>
            <span>产品名称：{{ productName }}</span>
            <span>保单号：{{ policyNo }}</span>
            <span
              >保险期间：{{ policyDetail.effectiveDateStr }}至{{
                policyDetail.expireDateStr
              }}</span
            >
          </div>
          <p>投保人信息</p>
          <div class="forminfo_">
            <div class="infoitem">
              <span>姓名:</span>
              <div class="itemright">
                <input
                  type="text"
                  :value="salPolicyHolder.name"
                  readonly
                  disabled
                  class="disabled_ele"
                />
              </div>
            </div>
            <div class="infoitem" style="flex:1.5">
              <span>证件号码:</span>
              <div class="itemright">
                <input
                  type="text"
                  :value="salPolicyHolder.idNumber"
                  readonly
                  disabled
                  class="disabled_ele"
                  style="width:180px;"
                />
              </div>
            </div>
            <div class="infoitem" v-if="salPolicyHolder.gender">
              <span>性别:</span>
              <div class="itemright">
                <input
                  type="text"
                  :value="salPolicyHolder.gender === 'F' ? '女' : '男'"
                  readonly
                  disabled
                  class="disabled_ele"
                />
              </div>
            </div>
            <div class="infoitem" v-if="salPolicyHolder.birthDate">
              <span>出生日期：</span>
              <div class="itemright datei_">
                <input
                  type="text"
                  :value="
                    salPolicyHolder.birthDate.indexOf('-') === -1
                      ? salPolicyHolder.birthDate.substring(0, 4) +
                        '-' +
                        salPolicyHolder.birthDate.substring(4, 6) +
                        '-' +
                        salPolicyHolder.birthDate.substring(6, 8)
                      : salPolicyHolder.birthDate
                  "
                  readonly
                  disabled
                  class="disabled_ele"
                />
              </div>
            </div>
          </div>
          <p>被保人信息</p>
          <div
            class="forminfo_"
            v-for="(item, index) in salInsuredList"
            :key="'pinfo' + index"
            :class="'pinfo' + index"
          >
            <div class="infoitem" v-stopdrag>
              <span>姓名:</span>
              <div class="itemright">
                <input type="text" v-model="item.name" />
              </div>
            </div>
            <div class="infoitem">
              <span>证件类型:</span>
              <div class="itemright">
                <select v-model="item.idType">
                  <option v-for="item1 in idTypeOptions" :value="item1.value">{{
                    item1.name
                  }}</option>
                </select>
                <i class="downicon"></i>
              </div>
            </div>
            <div class="infoitem" v-stopdrag>
              <span>证件号码:</span>
              <div class="itemright">
                <input
                  type="text"
                  v-model="item.idNumber"
                  @blur="textIdNumber(item.idType, item.idNumber, index)"
                />
              </div>
            </div>
            <div class="infoitem" v-stopdrag>
              <span>性别:</span>
              <div class="itemright">
                <select v-model="item.gender">
                  <option v-for="item1 in sexOptions" :value="item1.value">{{
                    item1.name
                  }}</option>
                </select>
                <span
                  class="selectmask"
                  v-if="item.idType === '1' || item.idType === '01'"
                ></span>
              </div>
            </div>
            <div class="infoitem" v-stopdrag>
              <span>出生日期：</span>
              <div class="itemright datei_">
                <a-date-picker
                  @change="(value,option) =>onChange(value,option,index)"
                  :defaultValue="
                    moment(
                      item.birthDate.indexOf('-') === -1
                        ? item.birthDate.substring(0, 4) +
                            '-' +
                            item.birthDate.substring(4, 6) +
                            '-' +
                            item.birthDate.substring(6, 8)
                        : item.birthDate,
                      dateFormat
                    )
                  "
                  :format="dateFormat"
                  :showToday="false"
                  :allowClear="false"
                  placeholder="请选择日期"
                />
                <span
                  class="selectmask"
                  v-if="item.idType === '1' || item.idType === '01'"
                ></span>
              </div>
            </div>
          </div>
          <div class="forminfo_ cor_date" v-stopdrag>
            <div class="infoitem">
              <span>批改生效日期：</span>
              <div class="itemright datei_" style="line-height: 30px;">
                <!-- <a-date-picker @change="onChangeS1" :defaultValue="moment(defaultDate1,dateFormat)" :format="dateFormat" :disabledDate="disabledDate" :showToday='false' :allowClear='false'/> -->
                {{ policyDetail.effectiveDateStr }}
                <!-- 同保单生效日期 -->
              </div>
            </div>
            <!-- <div class="infoitem">
                        <span>起保日期:</span>
                        <div class="itemright">
                            <input type="text" :value="salPolicy.effectiveDate.substring(0,10)" readonly/>
                        </div>
                    </div>
                    <div class="infoitem">
                        <span>终保日期:</span>
                        <div class="itemright">
                            <input type="text" :value="salPolicy.expireDate.substring(0,10)" readonly/>
                        </div>
                    </div> -->
          </div>
        </div>
        <div class="btn_b">
          <!-- <button @click="goNext(0)">投保人批改</button> -->
          <button @click="goNext(1)" :class="[disChangeBtn?'gray_':'']" :disabled='disChangeBtn'>确认批改</button>
        </div>
        <div class="absolute_con" v-if="showSureCorrect">
          <p>请确认是否提交批改?</p>
          <div class="btn_">
            <span @click="sureCorrect()">是</span>
            <span
              @click="
                showCorrect = false;
                showDetail = false;
                showSureCorrect = false;
              "
              >否</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import api from "@/utils/api";
const columns = [
  {
    title: "保单号",
    key: "policyNo",
    dataIndex: "policyNo",
    width: 150,
  },
  {
    title: "产品名称",
    key: "productName",
    dataIndex: "productName",
  },
  {
    title: "保费",
    key: "price",
    dataIndex: "price",
  },
  {
    title: "投保人",
    key: "holderName",
    dataIndex: "holderName",
  },
  {
    title: "起保日期",
    key: "startDate",
    dataIndex: "startDate",
  },
  {
    title: "终保日期",
    key: "endDate",
    dataIndex: "endDate",
  },
  {
    title: "操作",
    key: "1",
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  data() {
    document.title = "已出单保单";
    return {
      columns,
      isAfter: false, //判断当前时间与起保时间，是否展示退保按钮
      tableData: [],
      showDetail: false,
      dateFormat: "YYYY-MM-DD",
      pagination: {
        total: 0,
        pageSize: 20,
        pageNum: 1,
      },
      disChangeBtn:false,//禁用批改按钮
      createValue: [],
      policyDetail: {},
      step: 1,
      policyId: "",
      policyNo: "",
      status: 1,
      pageNum: "1",
      pageSize: "20",
      policyNoi: "",
      startDatei: "",
      endDatei: "",
      holderNamei: "",
      insuredNamei: "",
      statusOptions: [
        {
          type: "1",
          name: "已出单",
        },
        {
          type: "5",
          name: "已承保",
        },
      ],
      idTypeOptions: [
        {
          name: "身份证",
          value: "1",
        },
        {
          name: "护照",
          value: "2",
        },
        {
          name: "台湾通行证",
          value: "6",
        },
        {
          name: "港澳通行证",
          value: "4",
        },
      ],
      sexOptions: [
        {
          name: "男",
          value: "M",
        },
        {
          name: "女",
          value: "F",
        },
      ],
      defaultDate: "",
      provinceOptions: [],
      defaultProvince: "",
      defaultBank: "",
      defaultBankLoc: "",
      bankOptions: [],
      bankLocOptions: [],
      standardareaCode: "",
      bankDirectNumber: "",
      bankPointCode: "",
      bankPointName: "",
      accountName: "",
      remark: "",
      accountNo: "",
      showCorrect: false,
      salInsuredList: [],
      salPolicy: {},
      salPolicyHolder: {},
      defaultDate1: "",
      productName: "",
      showSureCorrect: false,
    };
  },
  filters: {
    filterType: (val, statusOptions) => {
      if (!val || val === "" || val === undefined) {
        return "";
      } else {
        let typeName = "";
        statusOptions.map((item) => {
          if (item.type == val) {
            typeName = item.name;
          }
        });
        return typeName;
      }
    },
    filterIdType: (val, idTypeOptions) => {
      if (!val || val === "" || val === undefined) {
        return "";
      } else {
        let idName = "";
        idTypeOptions.map((item) => {
          if (item.value == val) {
            idName = item.name;
          }
        });
        return idName;
      }
    },
    filterSex: (val, sexOptions) => {
      if (!val) {
        return "";
      } else {
        let idName = "";
        sexOptions.map((item) => {
          if (item.value == val) {
            idName = item.name;
          }
        });
        return idName;
      }
    },
    filterNull: (val) => {
      if (!val || val === "" || val === undefined) {
        return val;
      } else {
        return val.substring(0, 10);
      }
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlePageChange(e) {
      this.pageNum = e.current;
      this.initData();
    },
    initData() {
      this.policyNoi = "";
      this.createValue = [];
      this.startDatei = "";
      this.endDatei = "";
      this.holderNamei = "";
      this.insuredNamei = "";
      let queryData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.status,
      };
      this.queryData(queryData);
    },
    queryData(queryData) {
      api.findUserPolicy(queryData).then((res) => {
        if (res.data.returnCode === "0000" || res.data.data.list != null) {
          this.tableData = res.data.data.list.map((item, index) => {
            item.key = index;
            return item;
          });
          this.pagination.total = res.data.data.total;
        }
      });
    },
    searchData() {
      let queryData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.status,
        policyNo: this.policyNoi,
        startDate: this.startDatei,
        endDate: this.endDatei,
        holderName: this.holderNamei,
        insuredName: this.insuredNamei,
      };
      console.log(queryData, "queryData");
      this.queryData(queryData);
    },
    goDetail(policyId, policyNo, record) {
      console.log(policyId, policyNo, "policyId,policyNo");
      this.policyId = policyId;
      this.policyNo = policyNo;
      this.productName = record.productName;
      api.queryPolicyDetail(policyId).then((res) => {
        if (res.data.returnCode === "0000" || res.data.content != null) {
          this.showDetail = true;
          this.policyDetail = res.data.content;
          this.isAfter = moment().isAfter(this.policyDetail.effectiveDateStr);
          console.log(this.isAfter, "===isAfter");
          this.defaultDate = moment(
            res.data.content.salPolicy.effectiveDate != ""
              ? res.data.content.effectiveDateStr
              : ""
          )
            .add(1, "days")
            .format("YYYY-MM-DD");
          this.accountName = res.data.content.salPolicyHolder.name;
        }
      });
    },
    closeFix() {
      this.showDetail = false;
      this.showCorrect = false;
      this.showSureCorrect = false;
      this.step = 1;
      this.start()
    },
    rangeDate(dates, dateStrings) {
      this.createValue = dates;
      this.startDatei = dateStrings[0];
      this.endDatei = dateStrings[1];
    },
    stop(){ //禁止底层滚动
        document.querySelector('body').style.overflow='hidden';
    },
    start(){ //启用底层滚动
      document.querySelector('body').style.overflow='unset';
    },
    goSurrender() {
      if (moment().isBefore(this.policyDetail.effectiveDateStr)) {
        this.step = 2;
        this.queryArea();
        this.stop()
      } else {
        this.$notification.open({
          message: "退保提醒",
          description: "该保单已生效，不可退保！",
          duration: 2,
        });
      }
    },
    queryArea() {
      // 查询银行区域
      api.queryBankAreaInfos().then((res) => {
        if (res.data.returnCode === "0000" || res.data.content != null) {
          res.data.content.map((item) => {
            let itemdata = {
              value: item.standardareaCode,
              text: item.standardareaName.split("_").join("-"),
            };
            this.provinceOptions.push(itemdata);
          });
        }
      });
    },
    onChangeS(date, dateString) {
      this.defaultDate = dateString;
    },
    disabledDate(currentDate) {
      if (this.policyDetail.salPolicy) {
        return (
          currentDate &&
          (currentDate > moment(this.policyDetail.expireDateStr) ||
            currentDate <
              moment(this.policyDetail.effectiveDateStr).add(1, "days"))
        );
      }
    },
    areaChange(value, option) {
      this.standardareaCode = value;
      this.queryBank(value);
    },
    queryBank() {
      api
        .queryBankTypeInfos({ standardareaCode: this.standardareaCode })
        .then((res) => {
          if (res.data.returnCode === "0000" || res.data.content != null) {
            res.data.content.map((item) => {
              let itemdata = {
                value: item.bankDirectNumber,
                text: item.bankName,
              };
              this.bankOptions.push(itemdata);
            });
          }
        });
    },
    bankChange(value, option) {
      this.bankDirectNumber = value;
      this.queryBankChild();
    },
    queryBankChild() {
      api
        .queryBankInfos({
          standardareaCode: this.standardareaCode,
          bankDirectNumber: this.bankDirectNumber,
        })
        .then((res) => {
          if (res.data.returnCode === "0000" || res.data.content != null) {
            res.data.content.map((item) => {
              let itemdata = {
                value: item.bankPointCode,
                text: item.bankPointName,
              };
              this.bankLocOptions.push(itemdata);
            });
          }
        });
    },
    bankChildChange(value, option) {
      console.log(value, option, "value,option");
      this.bankPointCode = value;
      this.bankLocOptions.map((item) => {
        if (item.value === value) {
          this.bankPointName = item.text;
        }
      });
    },
    sureSurrender() {
      this.start()
      let form = {
        id: this.policyId,
        standardareaCode: this.standardareaCode,
        bankDirectNumber: this.bankDirectNumber,
        bankPointCode: this.bankPointCode,
        bankPointName: this.bankPointName,
        accountName: this.accountName,
        accountNo: this.accountNo,
        remark: this.remark,
      };
      console.log(form, "->>form");
      let regExp = /^([1-9]{1})(\d{15}|\d{18})$/;
      if (
        this.standardareaCode === "" ||
        this.bankDirectNumber === "" ||
        this.bankPointCode === ""
      ) {
        this.$notification.open({
          message: "操作提醒",
          description: "请选择银行区域，银行名称，开户行",
          duration: 2,
        });
      } else if (this.accountNo == "") {
        this.$notification.open({
          message: "操作提醒",
          description: "请输入银行卡号",
          duration: 2,
        });
      } else {
        api.closePolicy(form).then((res) => {
          this.$router.push({
            name: "policyResult",
            query: {
              data: res,
              type: "1",
            },
          });
        });
      }
    },
    getUrl(url, policyNo) {
      console.log(url, "url", policyNo, "url,policyNo");
      if (url != "" && url != null && url != undefined) {
        window.open(url, "_blank");
      } else {
        api.getDownloadPolicyUrl({ policyNo: policyNo }).then((res) => {
          if (
            res.data.returnCode === "0000" &&
            res.data.content != null &&
            res.data.content != ""
          ) {
            window.open(url, "_blank");
          } else {
            this.$notification.open({
              message: "操作提醒",
              description: res.data.returnMsg,
              duration: 2,
            });
          }
        });
      }
    },
    correct() {
      if (moment().isBefore(this.policyDetail.effectiveDateStr)) {
        this.showDetail = false;
        this.showCorrect = true;
        this.salInsuredList = this.policyDetail.salInsuredList;
        this.salPolicyHolder = this.policyDetail.salPolicyHolder;
        this.salPolicy = this.policyDetail.salPolicy;
        this.defaultDate1 = moment(this.salPolicy.effectiveDate.slice(0, 10))
          .add(1, "days")
          .format("YYYY-MM-DD");
        console.log(this.defaultDate1, "this.defaultDate1---");
      } else {
        this.$notification.open({
          message: "批改提醒",
          description: "该保单已生效，不可批改！",
          duration: 2,
        });
      }
    },
    // 身份证正则校验
    textIdNumber(type, num, index) {
      console.log(type, num, index, "num");
      let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      if (type === "1" || type === "01") {
        if (idcardReg.test(num)) {
          this.salInsuredList[index].birthDate =
            num.substr(6, 4) +
            "-" +
            num.substr(10, 2) +
            "-" +
            num.substr(12, 2);
          this.salInsuredList[index].gender =
            num.substring(16, 17) % 2 === 0 ? "F" : "M";
        } else {
          this.$notification.open({
            message: "操作提醒",
            description: "不合法的证件号码，请重新输入",
            duration: 2,
          });
        }
      }
    },
    onChange(date, dateString, index) {
      this.salInsuredList[index].birthDate = dateString;
    },
    onChange1(date, dateString) {
      this.salPolicyHolder.birthDate = dateString;
    },
    onChangeS1(date, dateString) {
      this.defaultDate1 = dateString;
    },
    goNext() {
      this.showSureCorrect = true;
    },
    sureCorrect() {
      this.showSureCorrect = false
      this.disChangeBtn = true
      let newdata = {};
      newdata = {
        salInsuredList: this.salInsuredList,
        salPolicyHolder: this.salPolicyHolder,
        salPolicy: this.salPolicy,
        issueDateStr: this.defaultDate1,
      };
      api.correctPolicy(newdata).then((res) => {
        this.$router.push({
          name: "policyResult",
          query: {
            data: res,
            type: "0",
          },
        });
      }).catch(err => {
        this.disChangeBtn = false
      })
    },
    disabledDate(currentDate) {
      return (
        currentDate &&
        (currentDate > moment(this.salPolicy.expireDate.slice(0, 10)) ||
          currentDate <
            moment(this.salPolicy.effectiveDate.slice(0, 10)).add(1, "days"))
      );
    },
  },
  directives: {
    drag: {
      // 指令的定义
      bind: function(el) {
        let odiv = el; //获取当前元素
        el.onmousedown = (e) => {
          //算出鼠标相对元素的位置
          let clientX = e.clientX;
          let disX = e.clientX - odiv.offsetLeft;
          let disY = e.clientY - odiv.offsetTop;
          let left = "";
          let top = "";
          document.onmousemove = (e) => {
            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            left = e.clientX - disX - 200; //(311为定位误差，看情况而定)
            top = e.clientY - disY;
            //绑定元素位置到positionX和positionY上面
            //移动当前元素
            const x = e.clientX - clientX;
            if (Math.abs(x) < 15) {
              return;
            } else {
              odiv.style.left = left + "px";
              odiv.style.top = top + "px";
            }
          };
          document.onmouseup = (e) => {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
    stopdrag: {
      inserted: function(el, binding, vnode) {
        let element = el;
        element.onmousedown = function(e) {
          e.stopPropagation();
        };
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.min_input_ {
  width: 64px;
}
.span_btn {
  a {
    color: #ff4c1c;
    margin-right: 8px;
    text-decoration: none;
    &:last-child {
      margin-right: 0;
    }
  }
}
.fixbg_ {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100vh;
  .fixcon {
    background-color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 960px;
    min-height: 500px;
    margin: 0 auto;
    max-height: 50vh;
    overflow-y: hidden;
    padding-top: 50px;
    padding-bottom: 40px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 8px;
    & > p {
      font-weight: bold;
      font-size: 15px;
      font-weight: bold;
      height: 50px;
      line-height: 50px;
      margin: 0;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      margin: 0 auto;
      padding: 0 30px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.07);
    }
    .close_ {
      width: 30px;
      height: 30px;
      background: url(../../../assets/wxmall/closeicon.png) center center
        no-repeat;
      background-size: 30px 30px;
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;
    }
    .detail {
      position: absolute;
      left: 0;
      right: 0;
      padding: 0 20px;
      bottom: 50px;
      top: 50px;
      overflow-y: scroll;
      > p {
        position: relative;
        font-weight: bold;
        padding-left: 10px;
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          content: "";
          display: block;
          width: 2px;
          height: 11px;
          margin: auto 0;
          background-color: #ff4c1c;
          border-radius: 1px;
        }
      }
      .table_ {
        margin-bottom: 30px;
      }
      table {
        width: 100%;
        border: 1px solid #f2f2f2;
        border-collapse: collapse;
        table-layout: fixed;
        th,
        td {
          padding: 10px;
          border: 1px solid #f2f2f2;
          word-break: break-all;
        }
      }
      .bold {
        font-weight: bold;
      }
    }
    .btn_b {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      padding-top: 8px;
      display: flex;
      justify-content: center;
      button {
        width: 100px;
        height: 35px;
        line-height: 35px;
        background-color: #ff4c1c;
        color: #fff;
        text-align: center;
        border: none;
        outline: none;
        border-radius: 4px;
        display: block;
        font-size: 15px;
        padding: 0;
        cursor: pointer;
        &:last-child {
          margin-left: 40px;
        }
        &:first-child {
          margin-right: 0;
        }
      }
    }
    .forminfo_ {
      display: flex;
      flex-direction: row;
      .infoitem {
        display: flex;
        flex: 1;
        margin-bottom: 20px;
        &.fl_2 {
          flex: 2;
          input {
            width: 200px;
          }
        }
        input {
          border: 1px solid #d9d9d9;
          background-color: transparent;
          width: 95px;
          padding-left: 5px;
          height: 32px;
          line-height: 32px;
          border-radius: 4px;
        }
        select {
          width: 100px;
          height: 32px;
          line-height: 32px;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
        span {
          white-space: nowrap;
          margin-right: 5px;
          // width:65px;
          text-align: left;
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
  .absolute_con {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
    width: 200px;
    background-color: #fff;
    box-shadow: 0px 3px 17px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 100;
    p {
      padding: 35px 0;
      text-align: center;
      color: #000;
      margin-bottom: 0;
    }
    .btn_ {
      display: flex;
      border-top: 1px solid rgba(0, 0, 0, 0.07);
      color: #ff4c1c;
      span {
        flex: 1;
        padding: 9px 0;
        text-align: center;
        cursor: pointer;
        &:first-child {
          background-color: #ff4c1c;
          color: #fff;
          border-bottom-left-radius: 8px;
        }
      }
    }
  }
}
.table_b {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.gray_ {
  background: #555 !important;
}

.itemright {
  position: relative;
}
.selectmask {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 5;
  left: 0;
  right: 0;
  background-color: transparent;
  width: 100% !important;
}
.disabled_ele {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25);
}
.policy_info {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 18px;
  font-weight: bold;
  color: #000;
  border-radius: 19px;
  padding: 8px 0;
  margin: 17px auto;
  span {
    margin-right: 50px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
